// client/src/components/common/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthContext } from '../../contexts/AuthContext';
//import { login } from '../../../../server/controllers/authController';

const ProtectedRoute = ({ requiredRole }) => {
  const { user, loading, hasAccess } = useContext(AuthContext);

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  console.log(' user ----------------------->', user)
  
  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  

  // Check if user has required role
  if (requiredRole && !hasAccess(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // User is authenticated and authorized
  return <Outlet />;
};

export default ProtectedRoute;